import React from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { Fade } from "react-reveal";
import { greeting } from "../../portfolio.js";
import "./PrivacyNotice.css";
import { t } from "i18next";

function PrivacyNotice(props) {
  const theme = props.theme;

  return (
    <div className="privacy-main">
      <Header theme={theme} setTheme={props.setTheme} />
      <div className="basic-projects">
        <Fade bottom duration={2000} distance="40px">
          <div className="privacy-heading-div">
            <div className="privacy-heading-text-div">
              <h1
                className="privacy-heading-text"
                style={{ color: theme.text }}
              >
                {t("titles.privacy-notice")}
              </h1>

              <h5
                className="privacy-header-detail-text subTitle"
                style={{ color: theme.text }}
              >
                {t("sections.privacy-notice.titles.1")}
              </h5>
              <p
                className="privacy-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                {t("sections.privacy-notice.content.1")}
              </p>

              <h5
                className="privacy-header-detail-text-subtile subTitle"
                style={{ color: theme.text }}
              >
                {t("sections.privacy-notice.titles.2")}
              </h5>
              <p
                className="privacy-header-detail-text"
                style={{ color: theme.secondaryText }}
              >
                {t("sections.privacy-notice.content.2")}
              </p>

              <h5
                className="privacy-header-detail-text-subtile subTitle"
                style={{ color: theme.text }}
              >
                {t("sections.privacy-notice.titles.3")}
              </h5>
              <p
                className="privacy-header-detail-text"
                style={{ color: theme.secondaryText }}
              >
                {t("sections.privacy-notice.content.3.1")}
              </p>
              <p
                className="privacy-header-detail-text"
                style={{ color: theme.secondaryText }}
              >
                {t("sections.privacy-notice.content.3.2")}
                <ul>
                  <li>{t("sections.privacy-notice.content.3.3")}</li>
                  <li>{t("sections.privacy-notice.content.3.4")}</li>
                  <li>{t("sections.privacy-notice.content.3.5")}</li>
                  <li>{t("sections.privacy-notice.content.3.6")}</li>
                  <li>{t("sections.privacy-notice.content.3.7")}</li>
                  <li>{t("sections.privacy-notice.content.3.8")}</li>
                  <li>{t("sections.privacy-notice.content.3.9")}</li>
                  <li>{t("sections.privacy-notice.content.3.10")}</li>
                  <li>{t("sections.privacy-notice.content.3.11")}</li>
                  <li>{t("sections.privacy-notice.content.3.12")}</li>
                </ul>
              </p>

              <h5
                className="privacy-header-detail-text-subtile subTitle"
                style={{ color: theme.text }}
              >
                {t("sections.privacy-notice.titles.4")}
              </h5>
              <p
                className="privacy-header-detail-text"
                style={{ color: theme.secondaryText }}
              >
                {t("sections.privacy-notice.content.4")}
              </p>

              <h5
                className="privacy-header-detail-text-subtile subTitle"
                style={{ color: theme.text }}
              >
                {t("sections.privacy-notice.titles.5")}
              </h5>
              <p
                className="privacy-header-detail-text"
                style={{ color: theme.secondaryText }}
              >
                {t("sections.privacy-notice.content.5")}
              </p>

              <h5
                className="privacy-header-detail-text-subtile subTitle"
                style={{ color: theme.text }}
              >
                {t("sections.privacy-notice.titles.6")}
              </h5>
              <p
                className="privacy-header-detail-text"
                style={{ color: theme.secondaryText }}
              >
                {t("sections.privacy-notice.content.6.1")}
              </p>
              <p
                className="privacy-header-detail-text"
                style={{ color: theme.secondaryText }}
              >
                {t("sections.privacy-notice.content.6.2")}
              </p>
              <p
                className="privacy-header-detail-text"
                style={{ color: theme.secondaryText }}
              >
                {t("sections.privacy-notice.content.6.3")}
              </p>
              <p
                className="privacy-header-detail-text"
                style={{ color: theme.secondaryText }}
              >
                {t("sections.privacy-notice.content.6.4")}
              </p>

              <h5
                className="privacy-header-detail-text-subtile subTitle"
                style={{ color: theme.text }}
              >
                {t("sections.privacy-notice.titles.7")}
              </h5>
              <p
                className="privacy-header-detail-text"
                style={{ color: theme.secondaryText }}
              >
                {t("sections.privacy-notice.content.7.1")}
                <br></br>
                <a
                  href={`mailto:${greeting.email}?subject=${
                    greeting.subject || ""
                  }&body=${greeting.body || ""}`}
                >
                  <span style={{ color: theme.accentColor }}>
                    {greeting.email}
                  </span>
                </a>
              </p>
              <p
                className="privacy-header-detail-text"
                style={{ color: theme.secondaryText }}
              >
                {t("sections.privacy-notice.content.7.2")}
                <br></br>
                <a
                  href={`mailto:${greeting.email}?subject=${
                    greeting.subject || ""
                  }&body=${greeting.body || ""}`}
                >
                  <span style={{ color: theme.accentColor }}>
                    {greeting.email}
                  </span>
                </a>
              </p>

              <h5
                className="privacy-header-detail-text-subtile subTitle"
                style={{ color: theme.text }}
              >
                {t("sections.privacy-notice.titles.8")}
              </h5>
              <p
                className="privacy-header-detail-text"
                style={{ color: theme.secondaryText }}
              >
                {t("sections.privacy-notice.content.8.1")}
              </p>
              <p
                className="privacy-header-detail-text"
                style={{ color: theme.secondaryText }}
              >
                {t("sections.privacy-notice.content.8.2")}
              </p>
              <p
                className="privacy-header-detail-text"
                style={{ color: theme.secondaryText }}
              >
                {t("sections.privacy-notice.content.8.3")}
              </p>

              <h5
                className="privacy-header-detail-text-subtile subTitle"
                style={{ color: theme.text }}
              >
                {t("sections.privacy-notice.titles.9")}
              </h5>
              <p
                className="privacy-header-detail-text"
                style={{ color: theme.secondaryText }}
              >
                {t("sections.privacy-notice.content.9.1")}
                <a href={`https://www.gruposangabriel.com.mx`}>
                  <span style={{ color: theme.accentColor }}>
                    {" www.gruposangabriel.com.mx"}
                  </span>
                </a>
              </p>
              <p
                className="privacy-header-detail-text"
                style={{ color: theme.secondaryText }}
              >
                {t("sections.privacy-notice.content.9.2")}
                <a
                  href={`mailto:${greeting.email}?subject=${
                    greeting.subject || ""
                  }&body=${greeting.body || ""}`}
                >
                  <span style={{ color: theme.accentColor }}>
                    {" " + greeting.email}
                  </span>
                </a>
              </p>
            </div>
          </div>
        </Fade>
      </div>
      <Footer theme={props.theme} onToggle={props.onToggle} />
    </div>
  );
}

export default PrivacyNotice;
